/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { CreateSberBeneficiaryMutationRequest, CreateSberBeneficiaryMutationResponse, CreateSberBeneficiary400, CreateSberBeneficiary401, CreateSberBeneficiary409, CreateSberBeneficiary429, CreateSberBeneficiary500, CreateSberBeneficiary502, CreateSberBeneficiary503 } from "../entities/CreateSberBeneficiary";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { createSberBeneficiary } from "../api/createSberBeneficiary";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const createSberBeneficiaryMutationKey = () => [{ url: '/api/v1/payouts/beneficiary' }] as const

export type CreateSberBeneficiaryMutationKey = ReturnType<typeof createSberBeneficiaryMutationKey>

export function createSberBeneficiaryMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CreateSberBeneficiaryMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = createSberBeneficiaryMutationKey()
        return mutationOptions<CreateSberBeneficiaryMutationResponse, ResponseErrorConfig<CreateSberBeneficiary400 | CreateSberBeneficiary401 | CreateSberBeneficiary409 | CreateSberBeneficiary429 | CreateSberBeneficiary500 | CreateSberBeneficiary502 | CreateSberBeneficiary503>, {data: CreateSberBeneficiaryMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return createSberBeneficiary(data, config)
          },
        })

}

/**
 * @description Создаёт анкету бенефициара (получателя средств) в Sber API — раздел «Безопасные сделки»,
 * схема «бенефициар-исполнитель». Используется перед первой выплатой водителю.
 * **Требования:**
 * - Аутентификация по заголовкам `user-id` и `city-id`
 * - Поддерживаемые типы: `individual` (резидент РФ) и `individual_non_resident` (нерезидент). Заполняется ровно одно поле.
 * - ИНН — 12 цифр
 * - `account` — только реквизиты СБП: `phone` (11–13 цифр, код страны с ведущими нулями) и `bankBIC` (9 цифр)
 * - Даты — формат `YYYY-MM-DD`
 * **Важно:**
 * - Поля `beneficiaryId`, `beneficiaryType`, `nominalAccountId` проставляет сервис — передавать их не нужно
 * - После успешного создания Сбер **асинхронно** (5–15 мин) переводит анкету в статус `ACTIVATED`
 * - Выплаты на бенефициара возможны только после активации
 * - Сервис является **прокси**: связку `driver_id ↔ beneficiary_id` хранит вызывающий сервис
 * @summary Создание анкеты бенефициара-исполнителя
 * {@link /api/v1/payouts/beneficiary}
 */
export function useCreateSberBeneficiary<TContext>(options: 
{
  mutation?: UseMutationOptions<CreateSberBeneficiaryMutationResponse, ResponseErrorConfig<CreateSberBeneficiary400 | CreateSberBeneficiary401 | CreateSberBeneficiary409 | CreateSberBeneficiary429 | CreateSberBeneficiary500 | CreateSberBeneficiary502 | CreateSberBeneficiary503>, {data: CreateSberBeneficiaryMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CreateSberBeneficiaryMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? createSberBeneficiaryMutationKey()

          const baseOptions = createSberBeneficiaryMutationOptions(config) as UseMutationOptions<CreateSberBeneficiaryMutationResponse, ResponseErrorConfig<CreateSberBeneficiary400 | CreateSberBeneficiary401 | CreateSberBeneficiary409 | CreateSberBeneficiary429 | CreateSberBeneficiary500 | CreateSberBeneficiary502 | CreateSberBeneficiary503>, {data: CreateSberBeneficiaryMutationRequest}, TContext>
          

          return useMutation<CreateSberBeneficiaryMutationResponse, ResponseErrorConfig<CreateSberBeneficiary400 | CreateSberBeneficiary401 | CreateSberBeneficiary409 | CreateSberBeneficiary429 | CreateSberBeneficiary500 | CreateSberBeneficiary502 | CreateSberBeneficiary503>, {data: CreateSberBeneficiaryMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CreateSberBeneficiaryMutationResponse, ResponseErrorConfig<CreateSberBeneficiary400 | CreateSberBeneficiary401 | CreateSberBeneficiary409 | CreateSberBeneficiary429 | CreateSberBeneficiary500 | CreateSberBeneficiary502 | CreateSberBeneficiary503>, {data: CreateSberBeneficiaryMutationRequest}, TContext>
      
}